const normalizeSidebarWorkspaceLabel = (value) => {
  const normalizedValue = String(value || '').trim();
  const normalizedLower = normalizedValue.toLowerCase();

  if (!normalizedValue || normalizedLower === 'thread' || normalizedLower === 'threads') {
    return 'Tasks';
  }

  return normalizedValue;
};

export default normalizeSidebarWorkspaceLabel;
